import escape from 'lodash.escape';

/**
 * Encodes an HTML string. See https://lodash.com/docs#escape
 */
export default escape;
